import type { RouteObject } from 'react-router-dom'
import { AccountOrdersPage } from './pages/AccountOrdersPage'
import { OrderDetailsPage } from './pages/OrderDetailsPage'

export const ordersRoutes: RouteObject[] = [
  {
    index: true,
    element: <AccountOrdersPage />,
  },
  {
    path: ':orderNumber',
    element: <OrderDetailsPage />,
  },
]
